/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const FavoriteFilled = (props: any) => (
<svg {...props}   viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="32px/favorite filled">
<path id="Path (Stroke)" d="M15.1726 10.2286L15.9999 11.4473L16.8273 10.2286C17.2273 9.6395 17.7387 9.14153 18.3266 8.76708C19.0923 8.27941 19.9893 8 20.95 8C23.705 8 26 10.3269 26 13.2748C26 16.6115 24.1304 19.4765 21.8623 21.7151C19.6054 23.9425 17.075 25.4271 16.0326 25.9901C16.0161 25.999 16.0055 26 16 26C15.9945 26 15.9839 25.999 15.9674 25.9901C14.925 25.4271 12.3946 23.9425 10.1377 21.7151C7.86957 19.4765 6 16.6115 6 13.2748C6 10.3269 8.2952 8 11.05 8C12.0108 8 12.9078 8.27941 13.6734 8.76703C14.2614 9.14147 14.7727 9.63944 15.1726 10.2286Z" fill="currentColor" stroke="inherit" strokeWidth="inherit"/>
</g>
</svg>
);

export default FavoriteFilled;